"use client";

interface TocItem {
  id: string;
  text: string;
  level: number;
}

export function TableOfContents({ content }: { content: string }) {
  const headings = extractHeadings(content);

  if (headings.length < 3) return null;

  return (
    <nav className="mb-8 rounded-lg border border-border bg-muted/50 p-4">
      <h2 className="mb-3 text-sm font-semibold text-foreground">
        Table of Contents
      </h2>
      <ul className="space-y-1">
        {headings.map((heading) => (
          <li
            key={heading.id}
            style={{ paddingLeft: `${(heading.level - 2) * 16}px` }}
          >
            <a
              href={`#${heading.id}`}
              className="text-sm text-muted-foreground hover:text-secondary"
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

function extractHeadings(markdown: string): TocItem[] {
  const headingRegex = /^(#{2,3})\s+(.+)$/gm;
  const headings: TocItem[] = [];
  let match: RegExpExecArray | null;

  while ((match = headingRegex.exec(markdown)) !== null) {
    const rawText = match[2];
    const hashes = match[1];
    if (!rawText || !hashes) continue;
    const text = rawText.trim();
    headings.push({
      id: text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, ""),
      text,
      level: hashes.length,
    });
  }

  return headings;
}
